import { useParams, useSearchParams } from "react-router-dom";
import { useGetFlightsQuery } from "src/store/slices/flights/Flights";
import { mapFlightSearchToSubmitObject } from "../utils";
import { useEffect, useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/store";
import { resetTimerState, setMaxTimeThunk, setRestartFlag, setSearchId, startTimer } from "src/store/slices/timer/timer.slice";
import dayjs from "dayjs";
import { simpleHash } from "src/utility";

export default function useFlightsSearch() {
  
  const [searchParams] = useSearchParams();
  const time = searchParams.get("t") ?? "";
  const searchIdStore = useSelector((state:RootState)=>state.timer.searchId);
  const dispatch = useDispatch<AppDispatch>();
  const { searchId } = useParams();
  const searchFormInputJSON = localStorage.getItem(searchId ?? "");
  const notFound = searchId !== undefined && searchFormInputJSON === null;
  const searchFormInputObject = useMemo(() => (searchFormInputJSON ? JSON.parse(searchFormInputJSON) : null), [searchId]);
  const requestObject = useMemo(() => ({request:mapFlightSearchToSubmitObject(searchFormInputObject)!,time}), [searchFormInputObject,time]);
  const responseObject = useGetFlightsQuery(requestObject, {
    skip: !requestObject,
    refetchOnMountOrArgChange:false,
    refetchOnFocus: false,
  });

  const {data, isFetching } = responseObject;

  useEffect(() => {
    dispatch(setRestartFlag(time));
  }, [time, dispatch]);

  useEffect(() => {
  const {hash} = simpleHash(JSON.stringify(requestObject),6,time);
  if (searchIdStore === hash || notFound) return;
  dispatch(resetTimerState());
  const isEmpty = data?.journeys.length === 0;
  if (isFetching || !data || isEmpty) return;
  const interval = dayjs(data.session.expiresAt).diff(
    data.session.startedAt,
    "millisecond"
  );

  dispatch(setMaxTimeThunk(interval));
  dispatch(startTimer());
  dispatch(setSearchId(hash))
}, [isFetching, data, dispatch, searchIdStore, time]);


  return {
    searchObject: searchFormInputObject,
    responseObject,
    notFound,
  };
}